import {useState,useEffect} from "react";
import ImageWithBasePath from "../../img";
import {Link,useNavigate} from "react-router-dom";
import {useDispatch,useSelector} from "react-redux";
import {setDataTheme} from "../../redux/themeSettingSlice";
import {all_routes} from "../../../feature-module/router/all_routes";
// -- biz9 --
import {Image,Style,Storage,System,User,App} from "../../../project";
import Authentication from '../../../feature-module/authentication';
import {Image_Type} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {User_Title,User_Logic,User_Role,User_Url} from "biz9-user";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image,Portal_Remote_User} from "biz9-portal-app";
import {Log,DateTime} from "biz9-utility";
import {Config,Url,Title,Type} from "../../../constant";
const Dashboard_Header = (props) => {
    /* -- DEFINE --
     * --- BUTTONZ ---
     * btn_logout - logout
     *
    */
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
    const handleDataThemeChange = (theme: string) => {
        dispatch(setDataTheme(theme));
    };
    const [hide_header,setHideHeader] = useState(props.hide_header);
    const [user,setUser] = useState(User.get());
    const [val_app_id,setValAppId] = useState(Storage.get_app().app_id);
    const [dashboard_type,setDashboardType] = useState(props.dashboard_type);
    const [apps,setApps] = useState(Storage.get_dashboard_apps() ? Storage.get_dashboard_apps() : []);
    const [is_dashboard_active,setIsDashboardActive] = useState(Storage.get_dashboard_type() == Type.DASHBOARD_USER);
    const [app_id_selected,setItemIdSelected] = useState(Storage.get_app() ? Storage.get_app().app_id : 0);
    useEffect(() => {
            const theme = localStorage.getItem("dataTheme") ? localStorage.getItem("dataTheme") : "light";
            dispatch(setDataTheme(theme));
            setDashboardType(props.dashboard_type);
            //get_data();
            }, [props]);
    async function get_data() {
    };
    async function btn_dashboard_user() {
        setIsDashboardActive(true);
        setItemIdSelected(0);
        Storage.post_dashboard_side_bar(Title.USER_SIDE_BAR_DASHBOARD);
        setDashboardType(Type.DASHBOARD_USER);
        Storage.post_dashboard_type_user();
        props.onUpdate(Type.DASHBOARD_USER);
    };
    async function btn_dashboard_app(app) {
        setIsDashboardActive(false);
        setItemIdSelected(app.app_id);
        setDashboardType(Type.DASHBOARD_APP);
        Storage.post_dashboard_type_app(app.app_id,app.url,app.service_url);
        props.onUpdate(Type.DASHBOARD_APP);
    };
    const onHandleMobileMenu = () => {
        // Toggle class on <html>
        const root = document.getElementsByTagName("html")[0];
        root.classList.toggle("menu-opened");
        // Toggle class on .main-wrapper
        const mainWrapper = document.querySelector(".main-wrapper");
        if (mainWrapper) {
            mainWrapper.classList.toggle("slide-nav");
        }
    };
    async function btn_logout(event) {
          event.preventDefault();
        //const [response,data] = await Portal_Remote_User.logout(App.get_url(Portal_Url.USER_LOGOUT),user);
        Storage.delete_all();
        navigate(all_routes.login);
    };
    async function btn_profile() {
        Storage.post_dashboard_side_bar(Type.DASHBOARD_USER);
    };
    return (
            <>
            <Authentication role={User_Role.USER} />
            {/* Header */}
            <header className="header dashboard-header" hidden={hide_header}>
            <div className="header-user">
            <div className="header-left-mob">
            <Link to={"#"} className="logo">
            <ImageWithBasePath src="/assets/img/dark-logo.png" alt="Logo" />
            </Link>
            </div>
            <Link id="mobile_btn" className="mobile_btn" to="#sidebar" onClick={() => onHandleMobileMenu()}>
            <span className="bar-icon">
            <i className="ti ti-baseline-density-medium" />
            </span>
            </Link>
            <div className="nav user-menu nav-list">
            </div>
            <div className="header-right d-flex align-items-center">
            <div className="dashboard-link">
            <ul className="d-inline-flex align-items-center p-1 rounded-pill">
            <li>
            <Link  onClick={() => btn_dashboard_user()} to={all_routes.dashboard_user_home} className={is_dashboard_active === true?"active":""}>
            Dashboard
            </Link>
            </li>
            {apps.map((item) => (
                        <li key={item.app_id}>
                        <Link key={item.app_id}
                        onClick={() => btn_dashboard_app(item)} className={app_id_selected === item.app_id ? 'active' : '' }
                        to={item.title == Type.DASHBOARD_USER ? Url.DASHBOARD_USER : Url.DASHBOARD_APP} >{item.title}</Link>
                        </li>
                        ))}
    </ul>
        </div>
        <div className="nav-item dropdown flag-nav nav-item-box">
        <Link className="nav-link dropdown-toggle" data-bs-toggle="dropdown" to="#"role="button">
        <i className={`ti  ${ dataTheme === "light" ? "ti-sun-high" : "ti-moon"}`}/>
        </Link>

        <ul className="dropdown-menu p-2">

        <li className="mb-1">

        <Link
        to="#"
        className={`dropdown-item theme-toggle ${
            dataTheme === "light" && "active"
        }`}
    id="light-mode-toggle"
        onClick={() => handleDataThemeChange("light")}>
        <i className="ti ti-sun-high me-2" />
        Light Mode
        </Link>
        </li>
        <li>
        <Link
        to="#"
        className={`dropdown-item theme-toggle rounded-2 ${
            dataTheme === "dark" && "active"
        }`}
    id="dark-mode-toggle"
        onClick={() => handleDataThemeChange("dark")}>
        <i className="ti ti-moon me-2" />
        Dark Mode
        </Link>
        </li>
        </ul>
        </div>
        {/*
            <div className="nav-item dropdown nav-item-box">
            <Link className="nav-link dropdown-toggle" to={"#"} data-bs-toggle="dropdown">
            <i className="ti ti-bell" />
            </Link>
            </div>
            */}
    <div className="nav-item dropdown nav-item-box">
        <Link to={"#"} className="dropdown-toggle d-flex align-items-center nav-link" data-bs-toggle="dropdown">
        <span className="avatar online avatar-sm">
        <ImageWithBasePath src={Image.get_url(user.image_filename,Image_Type.SQUARE_THUMB,{table:Portal_Table.USER})} alt="Img" className="img-fluid rounded-circle"/>
        </span>
        </Link>
        <div className="dropdown-menu p-0 dropdown-profile">
        <div className="d-flex align-items-center border-bottom p-2 mb-0">
        <div>
        <h6 className="fs-14 fw-medium mb-1">{user.username}{' - '}{User_Logic.get_user_role_by_role(user.role).title}</h6>
        <p className="fs-13 mb-0">{Title.LABEL_LAST_LOGIN}: {DateTime.get_date_short(user.last_login)}</p>
        </div>
        </div>
        <div className="p-2">

        <Link className="dropdown-item d-flex align-items-center mb-1" to={all_routes.home} >
        <i className="ti ti-user-bolt me-2" />
        BoSS AppZ
        </Link>
        <Link onClick={() => btn_profile()} className="dropdown-item d-flex align-items-center mb-1" to={all_routes.dashboard_user_profile_detail} >
        <i className="ti ti-settings-cog me-2" />
        Profile
        </Link>
        </div>
        <div className="border-top p-3">
        <Link
        onClick={btn_logout}
    to={'#'}
    className="btn btn-light btn-md w-100 border-0"
        >
       {Title.LABEL_LOGOUT}
        </Link>

        </div>
        </div>
        </div>
        </div>
        <div className="mobile-user-menu">
        <Link
        to={"#"}
    className="dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
        >
        <span className="avatar online avatar-sm">
        <ImageWithBasePath
        src="/assets/img/user/user-05.jpg"
        alt="Img"
        className="img-fluid rounded-circle"
        />
        </span>
        </Link>
        <div className="dropdown-menu p-0 dropdown-profile">
        <div className="d-flex align-items-center border-bottom p-2 mb-0">
        <span className="avatar avatar-lg me-2">
        <ImageWithBasePath
        src={Image.get_url(user.image_filename,Image_Type.SQUARE_THUMB,{table:Portal_Table.USER})}
    alt="img"
        className="rounded-circle"
        />
        </span>
        <div>
        <h6 className="fs-14 fw-medium mb-1">{user.username}{' - '}{User_Logic.get_user_role_by_role(user.role).title}</h6>
        <p className="fs-13 mb-0">Last Login: {DateTime.get_date_short(user.last_login)}</p>
        </div>
        </div>
        <div className="p-2">
        <Link className="dropdown-item d-flex align-items-center mb-1" to={all_routes.home} >
        <i className="ti ti-user-bolt me-2" />
        BoSS AppZ
        </Link>
        <Link onClick={() => btn_profile()} className="dropdown-item d-flex align-items-center mb-1" to={all_routes.dashboard_user_profile_detail} >
        <i className="ti ti-settings-cog me-2" />
        Profile
        </Link>
        </div>
        <div className="border-top p-3">
        <Link
        onClick={btn_logout}
    to={'#'}
    className="btn btn-light btn-md w-100 border-0"
        >
        Logout
        </Link>


        </div>
        </div>
        </div>
        </div>
        </header>
        {/* /Header */}
    </>
        );
};

export default Dashboard_Header;
